import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { db, firebase } from "@/firebase/firebaseConfig.js";
import moment from "moment-timezone";
const portMasterPilotMasterApi = AiseaApiFactory.get("portMasterPilotMaster");
const portMasterTugBoatMasterApi = AiseaApiFactory.get(
  "portMasterTugBoatMaster",
);
const portMasterVehicleMasterApi = AiseaApiFactory.get(
  "portMasterVehicleMaster",
);
const portMasterRopePickingBoatMasterApi = AiseaApiFactory.get(
  "portMasterRopePickingBoatMaster",
);
const portMasterTeamLeaderMasterApi = AiseaApiFactory.get(
  "portMasterTeamLeaderMaster",
);
const portMasterBerthMasterApi = AiseaApiFactory.get("portMasterBerthMaster");
const portMasterEnterpriseAgencyMasterApi = AiseaApiFactory.get(
  "portMasterEnterpriseAgencyMaster",
);
const portMasterPortWharfApi = AiseaApiFactory.get("portMasterPortWharf");
const portMasterPortSelectApi = AiseaApiFactory.get("portMasterPortSelect");
const portMasterVesselMasterApi = AiseaApiFactory.get("portMasterVesselMaster");
const vesselApi = AiseaApiFactory.get("vessel");

export default {
  /**
   * 当日、翌日、翌々日をセット.
   *
   * @param {*} payload
   */
  async setTargetDates({ state, commit, dispatch }, payload) {
    await dispatch("fetchMastersFromApi", payload);
    await dispatch("fetchMonitorsFromFirestore", payload);
    await dispatch("fetchColumnsFromFirestore", payload);

    // hour_intervalを考慮しつつ、現在日時から当日、翌日、翌々日を割り出す。
    const targetYmd = moment().local().format("YYYYMMDD");
    const nowDate = new Date();
    const dateStr = await dispatch("getOrderYmd", {
      targetYmd: targetYmd,
      newDate: nowDate,
    });

    const hourIntervalObj = state.masterMap["tasks"].find(
      (x) => x.id === "hour_interval",
    );
    const hourInterval = hourIntervalObj ? hourIntervalObj.value : "00:00";
    const dispDate =
      dateStr.slice(0, 4) +
      "-" +
      dateStr.slice(4, 6) +
      "-" +
      dateStr.slice(6, 8);
    const todayDate = dispDate + " " + hourInterval + ":00";

    const dateInfo = {
      today: moment(todayDate).local().format("YYYYMMDD"),
      tomorrow: moment(todayDate).add(1, "days").local().format("YYYYMMDD"),
      dayAfterTomorrow: moment(todayDate)
        .add(2, "days")
        .local()
        .format("YYYYMMDD"),
    };
    await commit("SET_TARGET_DATES", dateInfo);
  },

  /**
   * Firestoreの入出港タスク情報の変更を検知したときの処理.
   *
   * @param {*} payload
   */
  async subscribeDestinationWorkTasks({ state, commit, dispatch }, payload) {
    const enterprisePortPath = payload.hash;

    for (let targetDate of Object.keys(state.displayDates)) {
      let subscribeObj = await db
        .collection("pm_tasks")
        .doc(enterprisePortPath)
        .collection(state.displayDates[targetDate])
        .onSnapshot((snapshot) => {
          snapshot.docChanges().forEach((diff) => {
            if (diff.type !== "removed") {
              let taskData = {
                enterprisePortId: payload.id,
                date: state.displayDates[targetDate],
                taskId: diff.doc.id,
                docData: diff.doc.data(),
              };
              dispatch("saveTaskWithName", taskData);
            } else {
              let taskData = {
                date: state.displayDates[targetDate],
                taskId: diff.doc.id,
              };
              commit("DELETE_DESTINATION_WORK_TASK", taskData);
              commit(
                "SET_LAST_UPDATED_FOR_TASKS",
                Math.floor(moment().valueOf() / 1000),
              );
            }
          });
          let timeData = {
            date: state.displayDates[targetDate],
            time: moment().format("YYYY/MM/DD HH:mm"),
          };
          commit("SET_LAST_UPDATED_TIME_MAP", timeData);
        });
      commit("ADD_FIRESTORE_SUBSCRIBE_LIST", subscribeObj);
    }
  },

  /**
   * Firestoreの入出港タスク情報(=idのみのデータ)にマスタ情報を使って名称などを付与.
   *
   * @param {*} payload
   */
  attachNameToDocData({ state }, payload) {
    const enterprisePortVessel = state.masterMap.vessels.find(
      (x) => x.id === payload.docData["vessel#id"],
    );

    // // 整形＋マスタ名を足す処理を追加
    let taskDataWithName = {
      docData: payload.docData, // マスタ名更新などで、再展開するために、元データは保持しておく。
      order_type: {
        valueMap: state.masterMap.order_type.find(
          (x) => String(x.id) === String(payload.docData.order_type),
        ),
      },
      order_at: {
        valueMap: {
          value: payload.docData.order_at
            ? payload.docData.order_at.seconds * 1000
            : null,
          date: payload.date,
        },
      },
      progress: {
        valueMap: state.masterMap.progress.find(
          (x) => String(x.id) == String(payload.docData.progress),
        ),
      },
      progress_at: {
        valueMap: {
          value: payload.docData.progress_at,
          date: payload.date,
          progress: String(payload.docData.progress),
        },
      },
      previous: {
        valueMap: {
          port_name: payload.docData["previous#port_name"],
          berth: state.masterMap.berth.find(
            (x) => x.id === payload.docData["previous#berth_id"],
          ),
          order_type: String(payload.docData.order_type),
        },
      }, // TODO: 要検証
      berth: {
        valueMap: state.masterMap.berth.find(
          (x) => x.id === payload.docData["berth#id"],
        ),
      },
      vessel: {
        valueMap: {
          enterprisePortVessel: enterprisePortVessel,
          task_name: payload.docData["task#name"],
          order_type: String(payload.docData.order_type),
          mmsi: payload.docData["vessel#mmsi"],
          imo: payload.docData["vessel#imo"],
          call_sign: payload.docData["vessel#call_sign"],
        },
      },
      head_count: {
        valueMap: {
          value: payload.docData["head_count#value"],
          color_id: payload.docData["head_count#color_id"],
          options: payload.docData["head_count#options"],
        },
      },
      bit: {
        valueMap: {
          left: payload.docData["bit#left"],
          left_options: payload.docData["bit#left_options"],
          right: payload.docData["bit#right"],
          right_options: payload.docData["bit#right_options"],
        },
      },
      flag: { valueMap: { value: payload.docData.flag } },
      boardside_type: {
        valueMap: state.masterMap.boardside_type.find(
          (x) => x.id === payload.docData.boardside_type,
        ),
      },
      shipping_agency: {
        valueMap: state.masterMap.shipping_agency.find(
          (x) => x.id === payload.docData["shipping_agency#id"],
        ),
      },
      caution_note: {
        valueMap: {
          value: enterprisePortVessel ? enterprisePortVessel.tags : null,
        },
      },
      required_note: { valueMap: { value: payload.docData.required_note } },
      sort_order: {
        valueMap: {
          value: payload.docData.sort_order,
          order_at_string: payload.docData.order_at
            ? moment(payload.docData.order_at.seconds * 1000)
                .local()
                .format("HH:mm")
            : "--:--",
          enterprisePortVessel: enterprisePortVessel,
        },
      },
      weather: {
        valueMap: state.masterMap.weather.find(
          (x) => x.id === payload.docData["weather#id"],
        ),
      },
      pilot: {
        valueMap: payload.docData["pilot#id"]
          ? Object.keys(payload.docData["pilot#id"])
              .filter((pilotId) =>
                state.masterMap["pilot"].find((x) => x.id === pilotId),
              )
              .map((pilotId) => {
                let a = JSON.parse(
                  JSON.stringify(
                    state.masterMap["pilot"].find((x) => x.id === pilotId),
                  ),
                );
                a.status = payload.docData["pilot#id"][pilotId];
                return a;
              })
              .find((x) => x)
          : null,
      },
      team_leader: {
        valueMap: payload.docData["team_leader#id"]
          ? Object.keys(payload.docData["team_leader#id"])
              .filter((pilotId) =>
                state.masterMap["team_leader"].find((x) => x.id === pilotId),
              )
              .map((pilotId) => {
                let a = JSON.parse(
                  JSON.stringify(
                    state.masterMap["team_leader"].find(
                      (x) => x.id === pilotId,
                    ),
                  ),
                );
                a.status = payload.docData["team_leader#id"][pilotId];
                return a;
              })
              .find((x) => x)
          : null,
      },
      vehicles: {
        valueMap: {
          value: payload.docData["vehicles#id"]
            ? Object.keys(payload.docData["vehicles#id"])
                .filter((equipmentId) =>
                  state.masterMap["vehicles"].find((x) => x.id === equipmentId),
                )
                .map((equipmentId) => {
                  let a = JSON.parse(
                    JSON.stringify(
                      state.masterMap["vehicles"].find(
                        (x) => x.id === equipmentId,
                      ),
                    ),
                  );
                  a.status = payload.docData["vehicles#id"][equipmentId];
                  return a;
                })
            : [],
          is_size: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "vehicles",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "vehicles",
              ).is_size
            : false,
          is_count: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "vehicles",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "vehicles",
              ).is_count
            : false,
          count: payload.docData["vehicles#count"],
        },
      },
      tug_boats: {
        valueMap: {
          value: payload.docData["tug_boats#id"]
            ? Object.keys(payload.docData["tug_boats#id"])
                .filter((equipmentId) =>
                  state.masterMap["tug_boats"].find(
                    (x) => x.id === equipmentId,
                  ),
                )
                .map((equipmentId) => {
                  let a = JSON.parse(
                    JSON.stringify(
                      state.masterMap["tug_boats"].find(
                        (x) => x.id === equipmentId,
                      ),
                    ),
                  );
                  a.status = payload.docData["tug_boats#id"][equipmentId];
                  return a;
                })
            : [],
          is_size: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "tug_boats",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "tug_boats",
              ).is_size
            : false,
          is_count: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "tug_boats",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "tug_boats",
              ).is_count
            : false,
          count: payload.docData["tug_boats#count"],
        },
      },
      rope_boats: {
        valueMap: {
          value: payload.docData["rope_boats#id"]
            ? Object.keys(payload.docData["rope_boats#id"])
                .filter((equipmentId) =>
                  state.masterMap["rope_boats"].find(
                    (x) => x.id === equipmentId,
                  ),
                )
                .map((equipmentId) => {
                  let a = JSON.parse(
                    JSON.stringify(
                      state.masterMap["rope_boats"].find(
                        (x) => x.id === equipmentId,
                      ),
                    ),
                  );
                  a.status = payload.docData["rope_boats#id"][equipmentId];
                  return a;
                })
            : [],
          is_size: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "rope_boats",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "rope_boats",
              ).is_size
            : false,
          is_count: state.destinationWorkHeaders.find(
            (equipment) => equipment.columnKey === "rope_boats",
          )
            ? state.destinationWorkHeaders.find(
                (equipment) => equipment.columnKey === "rope_boats",
              ).is_count
            : false,
          count: payload.docData["rope_boats#count"],
        },
      },
      input_type: {
        valueMap: state.masterMap.input_type.find(
          (x) => x.id === payload.docData["input_type"],
        ),
      },
      highlight: { valueMap: { value: payload.docData["highlight"] } },
    };

    for (let key of Object.keys(taskDataWithName)) {
      if (key !== "docData") {
        taskDataWithName[key]["taskId"] = payload.taskId;
        taskDataWithName[key]["columnKey"] = key;
        taskDataWithName[key]["changes"] =
          payload.docData.changes && payload.docData.changes[key]
            ? payload.docData.changes[key].seconds * 1000
            : null;
        taskDataWithName[key]["highlight"] = payload.docData["highlight"];
      }
    }

    // 船舶表示は、タスク詳細の役割も兼ねるので、taskDetailとして、タスク全体の情報も含める。
    // そのまま自己を格納すると、too much recursive になるので、ディープコピー。ag-grid-vueでrowDataの編集を優先する場合には注意。
    taskDataWithName.vessel.valueMap["task_detail"] = JSON.parse(
      JSON.stringify(taskDataWithName),
    );
    return taskDataWithName;
  },
  async saveTaskWithName({ dispatch, commit }, payload) {
    const taskDataWithName = await dispatch("attachNameToDocData", payload);

    // steteに保存.
    // 保存＆呼び出しを速くするため、state.destinationWorkTasksMap[payload.date][payload.taskId] の連想配列型で保存.
    let taskData = {
      date: payload.date,
      taskId: payload.taskId,
      destinationWorkTask: taskDataWithName,
    };
    commit("SET_DESTINATION_WORK_TASK", taskData);
    commit("SET_LAST_UPDATED_FOR_TASKS", Math.floor(moment().valueOf() / 1000));
  },

  /**
   * Firestoreのデータ更新イベント通知を受けて、各種更新データにFetch依頼.
   *
   * @param {*} payload
   */
  async subscribeEventUpdate({ commit, dispatch, state }, payload) {
    const enterprisePortPath = payload.hash;

    let subscribeObj = await db
      .collection("pm_settings")
      .doc(enterprisePortPath)
      .collection("events")
      .onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((diff) => {
          if (diff.doc.id === "columns") {
            if (
              diff.doc.data().timestamp.seconds > state.lastUpdatedForColumns
            ) {
              dispatch("fetchColumnsFromFirestore", payload);
            }
          } else if (diff.doc.id === "monitors") {
            if (
              diff.doc.data().timestamp.seconds > state.lastUpdatedForMonitors
            ) {
              dispatch("fetchMonitorsFromFirestore", payload);
            }
          } else if (diff.doc.id === "datas") {
            if (
              diff.doc.data().timestamp.seconds > state.lastUpdatedForMasters
            ) {
              dispatch("fetchMastersFromApi", payload);
            }
          }
        });
      });
    commit("ADD_FIRESTORE_SUBSCRIBE_LIST", subscribeObj);
  },

  /**
   * 各種マスタ情報の一括取得(API,Firestore).
   *
   * @param {*} payload
   */
  async fetchMastersFromApi({ commit, dispatch, state }, payload) {
    let promiseAll = [];

    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterPortWharfApi.fetch(payload.id).then((resWharfs) => {
          if (!resWharfs.data || !resWharfs.data.wharfs) {
            reject("portMasterPortWharfApi error.");
          }
          let wharfsMasterList = {
            masterName: "wharfs",
            masterList: resWharfs.data.wharfs,
          };
          commit("SET_MASTER_MAP", wharfsMasterList);
          resolve("wharfs");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterBerthMasterApi.fetch(payload.id).then((resBerth) => {
          if (!resBerth.data || !resBerth.data.berths) {
            reject("portMasterBerthMasterApi error.");
          }
          let berthMasterList = {
            masterName: "berth",
            masterList: resBerth.data.berths,
          };
          commit("SET_MASTER_MAP", berthMasterList);
          resolve("berth");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterTeamLeaderMasterApi
          .fetch(payload.id)
          .then((resTeamLeader) => {
            if (!resTeamLeader.data || !resTeamLeader.data.team_leaders) {
              reject("portMasterTeamLeaderMasterApi error.");
            }
            let teamLeaderMasterList = {
              masterName: "team_leader",
              masterList: resTeamLeader.data.team_leaders,
            };
            commit("SET_MASTER_MAP", teamLeaderMasterList);
            resolve("team_leader");
          });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterEnterpriseAgencyMasterApi
          .fetch(payload.id)
          .then((resShippingAgency) => {
            if (
              !resShippingAgency.data ||
              !resShippingAgency.data.shipping_agencies
            ) {
              reject("portMasterEnterpriseAgencyMasterApi error.");
            }
            let shippingAgencyMasterList = {
              masterName: "shipping_agency",
              masterList: resShippingAgency.data.shipping_agencies,
            };
            commit("SET_MASTER_MAP", shippingAgencyMasterList);
            resolve("shipping_agency");
          });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterVesselMasterApi.fetch(payload.id).then((resVessels) => {
          if (!resVessels.data || !resVessels.data.vessels) {
            reject("portMasterVesselMasterApi error.");
          }
          let vesselMasterList = {
            masterName: "vessels",
            masterList: resVessels.data.vessels,
          };
          commit("SET_MASTER_MAP", vesselMasterList);
          resolve("vessels");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterPilotMasterApi.fetch(payload.id).then((resPilot) => {
          if (!resPilot.data || !resPilot.data.pilots) {
            reject("portMasterPilotMasterApi error.");
          }
          let pilotMasterList = {
            masterName: "pilot",
            masterList: resPilot.data.pilots,
          };
          commit("SET_MASTER_MAP", pilotMasterList);
          resolve("pilot");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterTugBoatMasterApi.fetch(payload.id).then((resTugBoats) => {
          if (!resTugBoats.data || !resTugBoats.data.tug_boats) {
            reject("portMasterTugBoatMasterApi error.");
          }
          let tugBoatsMasterList = {
            masterName: "tug_boats",
            masterList: resTugBoats.data.tug_boats,
          };
          commit("SET_MASTER_MAP", tugBoatsMasterList);
          resolve("tug_boats");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterRopePickingBoatMasterApi
          .fetch(payload.id)
          .then((resRopeBoats) => {
            if (!resRopeBoats.data || !resRopeBoats.data.rope_picking_boats) {
              reject("portMasterRopePickingBoatMasterApi error.");
            }
            let ropeBoatsMasterList = {
              masterName: "rope_boats",
              masterList: resRopeBoats.data.rope_picking_boats,
            };
            commit("SET_MASTER_MAP", ropeBoatsMasterList);
            resolve("rope_boats");
          });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterVehicleMasterApi.fetch(payload.id).then((resVehicles) => {
          if (!resVehicles.data || !resVehicles.data.vehicles) {
            reject("portMasterVehicleMasterApi error.");
          }
          let vehiclesMasterList = {
            masterName: "vehicles",
            masterList: resVehicles.data.vehicles,
          };
          commit("SET_MASTER_MAP", vehiclesMasterList);
          resolve("vehicles");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve, reject) => {
        portMasterPortSelectApi.fetch().then((resPorts) => {
          if (!resPorts.data || !resPorts.data.ports) {
            reject("portMasterPortSelectApi error.");
          }
          let portsMasterList = {
            masterName: "ports",
            masterList: resPorts.data.ports,
          };
          commit("SET_MASTER_MAP", portsMasterList);
          resolve("ports");
        });
      }),
    );
    promiseAll.push(
      new Promise((resolve) => {
        let boardsideTypeMasterList = {
          masterName: "boardside_type",
          masterList: [
            { id: 1, name: "左" },
            { id: 2, name: "右" },
            { id: 3, name: "左○" },
            { id: 4, name: "右○" },
            { id: 5, name: "？" },
          ],
        };
        commit("SET_MASTER_MAP", boardsideTypeMasterList);

        let pilotKanaMasterList = {
          masterName: "pilot_kana",
          masterList: [
            { id: 1, value: "あ", candidate: "あいうえおアイウエオ" },
            { id: 2, value: "か", candidate: "かきくけこカキクケコ" },
            { id: 3, value: "さ", candidate: "さしすせそサシスセソ" },
            { id: 4, value: "た", candidate: "たちつてとタチツテト" },
            { id: 4, value: "な", candidate: "なにぬねのナニヌネノ" },
            { id: 4, value: "は", candidate: "はひふへほハヒフヘホ" },
            { id: 4, value: "ま", candidate: "まみむめもマミムメモ" },
            { id: 4, value: "や", candidate: "やゆよヤユヨ" },
            { id: 4, value: "ら", candidate: "らりるれろラリルレロ" },
            { id: 4, value: "わ", candidate: "わをんワヲン" },
          ],
        };
        commit("SET_MASTER_MAP", pilotKanaMasterList);

        let inputTypeMasterList = {
          masterName: "input_type",
          masterList: [
            { id: 1, name: "手入力" },
            { id: 2, name: "Excel" },
          ],
        };
        commit("SET_MASTER_MAP", inputTypeMasterList);

        resolve("localConstant");
      }),
    );

    // FireStoreコンスタントもSET_MASTER_MAPする。
    // const enterprisePortPath = payload.id + ':' + payload.hash;
    const enterprisePortPath = payload.hash;
    const collectionRef = db
      .collection("pm_settings")
      .doc(enterprisePortPath)
      .collection("constants");
    const snapshot = await collectionRef.get();
    snapshot.forEach((doc) => {
      let constantData = {
        masterName: doc.id,
        masterList: [],
      };

      if (doc.data().values && Array.isArray(doc.data().values)) {
        constantData.masterList = doc.data().values.map((data, index) => {
          return { id: index, value: data };
        });
      } else if (
        typeof doc.data().values === "object" &&
        doc.data().values !== null
      ) {
        constantData.masterList = Object.keys(doc.data().values).map((key) => {
          return { id: key, value: doc.data().values[key] };
        });
      } else {
        constantData.masterList = Object.keys(doc.data()).map((key) => {
          return { id: key, value: doc.data()[key] };
        });
      }

      commit("SET_MASTER_MAP", constantData);

      if (["head_count", "progress"].includes(doc.id)) {
        let constantColors = {
          masterName: doc.id + "_colors",
          masterList: [],
        };
        if (doc.data().colors && Array.isArray(doc.data().colors)) {
          constantColors.masterList = doc.data().colors.map((data, index) => {
            return { id: index, value: data };
          });
        } else if (
          typeof doc.data().colors === "object" &&
          doc.data().colors !== null
        ) {
          constantColors.masterList = Object.keys(doc.data().colors).map(
            (key) => {
              return { id: key, value: doc.data().colors[key] };
            },
          );
        }
        commit("SET_MASTER_MAP", constantColors);
      }

      if (doc.id === "order_type") {
        let constantOrderTypeSorts = {
          masterName: doc.id + "_sorts",
          masterList: [],
        };
        if (doc.data().sorts && Array.isArray(doc.data().sorts)) {
          constantOrderTypeSorts.masterList = doc
            .data()
            .sorts.map((data, index) => {
              return { id: index, value: String(data) };
            });
        }
        commit("SET_MASTER_MAP", constantOrderTypeSorts);
      }
    });

    await Promise.all(promiseAll);

    // マスタ情報が更新されたので、タスク情報にマスタ名を再び付与.
    Object.values(state.displayDates).forEach((targetDate) => {
      let taskMapByDate = state.destinationWorkTasksMap[targetDate];
      if (taskMapByDate) {
        Object.keys(taskMapByDate).forEach((taskId) => {
          let taskData = {
            enterprisePortId: payload.id,
            date: targetDate,
            taskId: taskId,
            docData: taskMapByDate[taskId].docData, // docData = Firestore取得直後に保存していた生データ。
          };

          dispatch("saveTaskWithName", taskData);
        });
      }
    });

    commit(
      "SET_LAST_UPDATED_FOR_MASTERS",
      Math.floor(moment().valueOf() / 1000),
    );
  },

  /**
   * Firestore ディスプレイ設定を取得し、stateに保存.
   *
   * @param {*} payload
   */
  async fetchMonitorsFromFirestore({ commit }, payload) {
    const enterprisePortPath = payload.hash;

    const collectionRef = db
      .collection("pm_settings")
      .doc(enterprisePortPath)
      .collection("monitors");

    const snapshot = await collectionRef.get();
    snapshot.forEach((doc) => {
      let payload = {
        id: doc.id,
        setting: doc.data(),
      };
      commit("SET_MONITOR_SETTING_MAP", payload);
    });

    commit(
      "SET_LAST_UPDATED_FOR_MONITORS",
      Math.floor(moment().valueOf() / 1000),
    );
  },

  /**
   * Firestore 表示設定を取得し、stateに保存.
   *
   * @param {*} payload
   */
  async fetchColumnsFromFirestore({ commit }, payload) {
    const enterprisePortPath = payload.hash;
    const collectionRef = db
      .collection("pm_settings")
      .doc(enterprisePortPath)
      .collection("columns");
    const snapshot = await collectionRef.get();
    let columnDataMap = {};
    snapshot.forEach((doc) => {
      columnDataMap[doc.id] = doc.data();
    });

    let destinationWorkHeaders = [];
    for (let columnKey of Object.keys(columnDataMap)) {
      let destinationWorkHeader = columnDataMap[columnKey];
      destinationWorkHeader["columnKey"] = columnKey;
      destinationWorkHeaders.push(destinationWorkHeader);
    }

    destinationWorkHeaders.sort((a, b) => {
      // sortでソート
      let comparison = 0;
      if (a.sort > b.sort) {
        comparison = 1;
      } else if (a.sort < b.sort) {
        comparison = -1;
      }
      return comparison;
    });

    commit("SET_DESTINATION_WORK_HEADERS", destinationWorkHeaders);
    commit(
      "SET_LAST_UPDATED_FOR_COLUMNS",
      Math.floor(moment().valueOf() / 1000),
    );
  },

  /**
   * aisea vessels.idの検索.
   *
   * @param {*} payload
   */
  async searchVessel(_nouse, payload) {
    let vesselItems = [];
    if (payload.mmsi) {
      vesselItems.push(payload.mmsi);
    }
    if (payload.imo) {
      vesselItems.push(payload.imo);
    }
    if (payload.call_sign) {
      vesselItems.push(payload.call_sign);
    }

    let resVesselSearch0 =
      vesselItems.length > 0
        ? await vesselApi.search(vesselItems.join(","))
        : null;
    let vessel =
      resVesselSearch0 && resVesselSearch0.data
        ? resVesselSearch0.data.vessels[0]
        : {};

    return vessel;
  },

  /**
   * 更新id値から更新後の入出港のタスク情報を生成する。
   *
   * @param {*} updateData
   */
  async mergeUpdateDataIntoTaskRecord({ state, dispatch }, updateData) {
    // stateからタスク1行の生データを取得
    let stateTaskDocData =
      state.destinationWorkTasksMap[
        state.displayDates[state.selectedDateDisplay1]
      ][updateData.taskId].docData;

    // changesを生成

    const changeTimestamp = {};
    const currentTimeValue = moment().valueOf();
    changeTimestamp.changes = {};

    if (updateData.updateTimeStamp) {
      for (let key of Object.keys(updateData.data)) {
        if (key !== "changes" && key !== "highlight") {
          const columnKey = key.replace(/#.*$/i, "");
          changeTimestamp.changes[columnKey] = {
            seconds: Math.floor(currentTimeValue / 1000),
            nanoseconds: 0,
          };
        }
      }
    }

    // updateDataをマージして、新しいタスク行を生成。
    const mergedChanges = Object.assign(
      {},
      stateTaskDocData.changes,
      changeTimestamp.changes,
    );
    const newStateTaskDocData = Object.assign(
      {},
      stateTaskDocData,
      updateData.data,
      { changes: mergedChanges },
    );

    // 日付データは、Date型 → FireStoreTimestamp型に変換してから、新しいタスク行に再上書き。
    for (let columnKey of Object.keys(updateData.data)) {
      if (columnKey === "order_at") {
        newStateTaskDocData[columnKey] = !updateData.data[columnKey]
          ? null
          : {
              seconds: Math.floor(updateData.data[columnKey].getTime() / 1000),
              nanoseconds: 0,
            };
      } else if (columnKey === "progress_at") {
        const progress = String(newStateTaskDocData["progress"]);
        if (!newStateTaskDocData[columnKey]) {
          newStateTaskDocData[columnKey] = {};
        }
        newStateTaskDocData[columnKey][progress] =
          !updateData.data[columnKey] || !updateData.data[columnKey][progress]
            ? null
            : {
                seconds: Math.floor(
                  updateData.data[columnKey][progress].getTime() / 1000,
                ),
                nanoseconds: 0,
              };
      }
    }
    // idだけのデータにマスタデータの名前を付与。
    let newTaskData = {
      enterprisePortId: updateData.enterprisePort.id,
      date: state.displayDates[state.selectedDateDisplay1],
      taskId: updateData.taskId,
      docData: newStateTaskDocData,
    };
    const newTaskWithName = await dispatch("attachNameToDocData", newTaskData);

    return newTaskWithName;
  },

  /**
   * Firestorの入出港タスク情報を更新
   *
   * @param {*} payload
   */
  async updateFirestoreDocument({ state, dispatch }, payload) {
    const enterprisePortPath = payload.enterprisePort.hash;
    const updateMode =
      payload.updateMode !== undefined ? payload.updateMode : false;
    const updateTimeStamp =
      payload.updateTimeStamp !== undefined ? payload.updateTimeStamp : false;
    const changeTimestamp = {};
    changeTimestamp.changes = {};
    for (let key of Object.keys(payload.data)) {
      if (key !== "changes") {
        const columnKey = key.replace(/#.*$/i, "");
        changeTimestamp.changes[columnKey] = updateTimeStamp
          ? new Date(moment().toISOString())
          : firebase.firestore.FieldValue.delete();
      }
    }

    let diaplayYmd = state.displayDates[state.selectedDateDisplay1];
    let orderAtYmd = payload.data["order_at"]
      ? await dispatch("getOrderYmd", {
          targetYmd: diaplayYmd,
          newDate: payload.data["order_at"],
        })
      : null;
    if (!orderAtYmd || diaplayYmd === orderAtYmd) {
      const docRef = db
        .collection("pm_tasks")
        .doc(enterprisePortPath)
        .collection(state.displayDates[state.selectedDateDisplay1])
        .doc(payload.taskId);

      if (
        payload.data["highlight"] !== undefined ||
        payload.data["sort_order"] !== undefined
      ) {
        docRef.set(payload.data, { merge: true });
      } else if (updateMode) {
        docRef.update(payload.data);
        docRef.set(changeTimestamp, { merge: true });
      } else {
        docRef.set(Object.assign({}, payload.data, changeTimestamp), {
          merge: true,
        });
      }
    } else {
      // オーダー時間の変更が表示日付を超えた場合。

      // insert
      if (updateTimeStamp) {
        db.collection("pm_tasks")
          .doc(enterprisePortPath)
          .collection(orderAtYmd)
          .doc(payload.taskId)
          .set(
            Object.assign(
              {},
              state.destinationWorkTasksMap[diaplayYmd][payload.taskId].docData,
              payload.data,
              changeTimestamp,
            ),
          );
      } else {
        db.collection("pm_tasks")
          .doc(enterprisePortPath)
          .collection(orderAtYmd)
          .doc(payload.taskId)
          .set(
            Object.assign(
              {},
              state.destinationWorkTasksMap[diaplayYmd][payload.taskId].docData,
              payload.data,
            ),
          );
        db.collection("pm_tasks")
          .doc(enterprisePortPath)
          .collection(orderAtYmd)
          .doc(payload.taskId)
          .set(changeTimestamp, { merge: true });
      }

      // remove
      db.collection("pm_tasks")
        .doc(enterprisePortPath)
        .collection(diaplayYmd)
        .doc(payload.taskId)
        .delete();
    }
  },

  /**
   * 修正後のオーダー時間から、表示対象日を算出する。（tasks.hour_intervalを考慮）
   *
   * payload.targetYmd: 表示対象日（文字列型：YYYYMMDD）
   * payload.newDate: 修正後オーダー日時（Date型）
   *
   */
  getOrderYmd({ state }, payload) {
    const hourIntervalObj = state.masterMap["tasks"].find(
      (x) => x.id === "hour_interval",
    );
    const hourInterval = hourIntervalObj ? hourIntervalObj.value : "00:00";
    if (payload.targetYmd && payload.newDate) {
      let hourIntervalTimeStr = `${payload.targetYmd.slice(
        0,
        4,
      )}-${payload.targetYmd.slice(4, 6)}-${payload.targetYmd.slice(
        6,
        8,
      )}T${hourInterval}:00`;
      for (let i = -30; i < 30; i++) {
        if (
          moment(payload.newDate).valueOf() >=
            moment(hourIntervalTimeStr).add(i, "days").valueOf() &&
          moment(payload.newDate).valueOf() <
            moment(hourIntervalTimeStr)
              .add(i + 1, "days")
              .valueOf()
        ) {
          return moment(hourIntervalTimeStr).add(i, "days").format("YYYYMMDD");
        }
      }
    }
    return null;
  },

  setSelectedDateDisplay1({ commit }, payload) {
    commit("SET_SELECTED_DATE_DISPLAY1", payload);
  },

  setVesselNameJapaneseFlg({ commit }, payload) {
    commit("SET_VESSEL_NAME_JAPANESE_FLG", payload);
  },

  setPilotColorFlg({ commit }, payload) {
    commit("SET_PILOT_COLOR_FLG", payload);
  },

  setSelectedCell({ commit }, payload) {
    commit("SET_SELECTED_CELL", payload);
  },

  setSummaryDialogShowPopup({ commit }, payload) {
    commit("SET_SUMMARY_DIALOG_SHOW_POPUP", payload);
  },

  // unsubscribe
  async unsubscribeFirestore({ commit }) {
    commit("UNSUBSCRIBE_FIRESTORE");
  },
};
